import { getProductDescription } from "./description";

const getVariantsStructuredData = variants => {
  const inStock = "https://schema.org/InStock";
  const outOfStock = "https://schema.org/OutOfStock";
  return variants.map(variant => ({
    "@type": "Offer",
    availability: variant.isAvailable ? inStock : outOfStock,
    itemCondition: "https://schema.org/NewCondition",
    price: variant.pricing?.price.gross.amount.toFixed(2) || 0,
    priceCurrency: variant.pricing?.price.gross.currency || "USD",
    sku: variant.sku,
  }));
};

export const structuredData = product => {
  const images = product.images.map(
    image => new URL(image.url, window.location.origin).href
  );
  const variants = product.variants;

  return JSON.stringify({
    "@context": "https://schema.org/",
    "@type": "Product",
    description: getProductDescription(product),
    image: images,
    name: !product.seoTitle ? `${product.name}` : `${product.seoTitle}`,
    offers: getVariantsStructuredData(variants),
    sku: variants.length === 1 ? variants[0].sku : undefined,
    url: window.location.href,
  });
};
